module.exports = __webpack_public_path__ + "media/images/area/area_naraM400-26459b5680ebdf9ee17817154d59eda3.jpg";